import { StoresScreen } from '../features/stores/StoresScreen'
import { useShell } from '../app/outlet'

export function StoresPage() {
  const { toast } = useShell()
  return <StoresScreen onToast={toast} />
}
